import styled, { css } from 'styled-components'
import { mobile } from '../utils/screenStyles'

export const StyledHeader1 = styled.h1.attrs(props => ({
  className: props.className
}))`
  color: ${props => props.color ? props.color : props.theme.colors.deepBlue};
  font-family: Montserrat;
  font-size: ${props => props.size ? props.size : props.theme.heading.desktop.h1};
  line-height: 36px;
  text-transform: uppercase;
  font-weight: bold;

  ${mobile`
    font-size: ${props => props.theme.heading.mobile.h1};
  `}
`

export const StyledHeader2 = styled.h2.attrs(props => ({
  className: props.className
}))`
  color: ${props => props.color ? props.color : props.theme.colors.deepBlue};
  font-family: Montserrat;
  font-size: ${props => props.size ? props.size : props.theme.heading.desktop.h2};
  line-height: 36px;

  ${mobile`
    font-size: ${props => props.theme.heading.mobile.h2};
  `}
`

export const StyledHeader3 = styled.h3.attrs(props => ({
  className: props.className
}))`
  color: ${props => props.color ? props.color : props.theme.colors.deepBlue};
  font-family: Montserrat;
  font-size: ${props => props.size ? props.size : props.theme.heading.desktop.h3};
  line-height: 24px;

  ${mobile`
    font-size: ${props => props.theme.heading.mobile.h3};
  `}
`

export const StyledHeader4 = styled.h4.attrs(props => ({
  className: props.className
}))`
  color: ${props => props.color ? props.color : props.theme.colors.deepBlue};
  font-family: Lato;
  font-size: ${props => props.size ? props.size : props.theme.heading.desktop.h4};
  line-height: 20px;

  ${mobile`
    font-size: ${props => props.theme.heading.mobile.h4};
  `}
`

export const StyledParagraph = styled.p.attrs(props => ({
  className: props.className
}))`
  font-family: Lato;
  font-size: ${props => props.size ? props.size : '14'}px;
  line-height: 20px;
  font-weight: 300;
  margin: 0;
  padding: 0;
  ${props => {
  if (props.styles) {
    return css`
        ${{ ...props.styles }}
      `
  }
}}
`

export const StyledLineTitle = styled.p.attrs(props => ({
  className: props.className
}))`
  color: ${props => props.color ? props.color : props.theme.colors.soilGray};
  font-family: Lato;
  font-size: ${props => props.size ? props.size : props.theme.font.size.big};
  line-height: 24px;
  font-family: Lato;
  letter-spacing: 0.75px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`
